import { api } from "../common/utils"
import { APIError, SearchResult } from "../types"
import { SMS_CONVERSATION_PDF_ENDPOINT } from "../common/constants"

const others = {
  getSearchAnything: async (params: {
    [key: string]: string | number
  }): Promise<SearchResult[] | APIError> => {
    const url = "/api/v1/search-anything"
    const { data } = await api.get(url, {
      params
    })
    return data || []
  },
  downloadConversationPdf: async (
    leadId: string,
    type?: "lead" | "subscription"
  ): Promise<{ file: string; label?: string } | APIError> => {
    let key: string
    switch (type) {
      case "lead":
        key = "lead_id"
        break
      case "subscription":
        key = "subscription_id"
        break
      default:
        key = "thread_id"
    }

    const { data } = await api.get(SMS_CONVERSATION_PDF_ENDPOINT, {
      params: {
        [key]: leadId
      }
    })
    return data
  }
}

export default others
